<div *ngFor="let tag of tagOptions" class="flex space-y-2 items-center">
  <p-checkbox
    [inputId]="tag.key"
    name="group"
    [value]="tag"
    [(ngModel)]="selectedTags"
    [disabled]="tag.disable"
    (onChange)="onTagSelection()"
  />
  <label [for]="tag.key" class="ml-2"> {{ tag.label }} </label>
</div>
<div class="mt-4 flex justify-end space-x-3">
  <button
    pButton
    label="Cancel"
    class="p-button-text"
    (click)="onCancel()"
  ></button>
  <button
    pButton
    label="Add"
    (click)="onEdit()"
  ></button>
</div>
